<template lang="pug">
  v-menu(
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  )
    template(v-slot:activator="{ on }")
      v-text-field(
        v-model="formatted"
        :label="label"
        readonly
        v-on="on"
        class="mr-1"
        :clearable="clearable"
        outlined
        hide-details
      )
        template(v-slot:append)
          slot(name="append")
    v-date-picker(
      v-model="valueModel"
      @input="menu=false;$emit('change')"
      :min="min"
      :max="max"
    )
</template>

<script>
  export default {
    data: () => ({
      menu: false
    }),
    props: {
      clearable: { default: false },
      min: { default: undefined },
      max: { default: undefined },
      label: {}, 
      value: {}
    },
    computed: {
      formatted: {
        get: function() {
          if(!this.value)
            return null
          else {
            const [year, month, day] = this.value.split('-')
            return `${month}/${day}/${year}`
          }
        },
        set: function(date) {
          if(!date)
            this.$emit('input', null)
          else {
            const [month, day, year] = date.split('/')
            this.$emit('input', `${year}-${month}-${day}`)
          }
        }
      },
      valueModel: {
        get: function() {
          return this.value
        },
        set: function(value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>